import { useLazyQuery, useMutation } from "@apollo/client/react";
import {
  Grid
} from '@mui/material';
import Chip from '@mui/material/Chip';
import { useEffect, useMemo, useState } from 'react';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';

import { useLocation } from 'react-router-dom';
import { adaptAlergiaArray } from '../../../adapters/alergiaAdapter';
import { adaptFranjaEtariaArray } from '../../../adapters/franjaEtariaAdapter';
import { adaptGrupoObligatorioArray } from '../../../adapters/grupoObligatorioAdapter';
import { adaptLumenesArray } from '../../../adapters/lumenesAdapter';
import { adaptPresentacionNutricionArray } from '../../../adapters/presentacionNutricionAdapter';
import { adaptTipoAccesoArray } from '../../../adapters/tipoAccesoAdapter';
import { adaptTipoInsumoArray } from '../../../adapters/tipoInsumoAdapter';
import { GET_GRUPO_OBLIGATORIO } from '../../../data/graphQL/queries/Insumos/getGrupoObligatorio';
import {
  GET_ALL_ALERGIAS,
  GET_ALL_PRESENTACION_NUTRICION,
  GET_ALL_TIPO_ACCESO,
  GET_LUMENES,
  GET_TIPO_INSUMOS
} from '../../../data/graphQL/queries/Insumos/queries';
import { GET_ALL_FRANJA_ETARIA } from '../../../data/graphQL/queries/PlanCuidado/getFranjaEtaria';
import './previewValidateContent.scss';

import { TextField } from '@mui/material';
import { adaptCriterioArray } from '../../../adapters/criterioAdapter';
import { adaptDelegacionArray } from '../../../adapters/delegacionAdapter';
import { adaptDocumentoLegalArray } from '../../../adapters/documentoLegalAdapter';
import { adaptFaseArray } from '../../../adapters/faseAdapters';
import { adaptFiguraProfesionalByIdArray } from '../../../adapters/figuraProfesionalAdapter';
import { adaptFrecuenciaProfesionalArray } from '../../../adapters/frecuenciaProfesionalAdapter';
import { adaptGrupoProfesionalArray } from '../../../adapters/grupoProfesionalAdapter';
import { adaptModalidadProfesionalCobroArray } from '../../../adapters/modalidadProfesionalCobro';
import { adaptModalidadVisitaArray } from '../../../adapters/modalidadVisitaAdapter';
import { adaptPlanCuidadoDuracionFaseArray } from '../../../adapters/planCuidadoDuracionFase';
import { adaptTipoCapacitacionArray } from '../../../adapters/tipoCapacitacionAdapter';
import { adaptTipoProfesionalArray } from '../../../adapters/tipoProfesionalAdapter';
import { adaptTipoProfesionalEspecialidadArray } from '../../../adapters/tipoProfesionalEspecialidadAdapter';
import { CHANGE_STATE_PLANCUIDADO } from '../../../data/graphQL/mutations/PlanCuidado/changeStatusPlanCuidado';
import { GET_ALL_CRITERIOS } from '../../../data/graphQL/queries/PlanCuidado/getCriterios';
import { GET_ALL_DOCUMENTOS_LEGALES } from '../../../data/graphQL/queries/PlanCuidado/getDocumentosLegales';
import { GET_ALL_FASES } from '../../../data/graphQL/queries/PlanCuidado/getFases';
import { GET_DELEGACIONES } from '../../../data/graphQL/queries/Planes/getDelegaciones';
import { GET_DOCUMENTOS } from '../../../data/graphQL/queries/Planes/getDocumentos';

import { adaptComplejidadArray } from '../../../adapters/complejidadAdapter';
import { adaptReporteVentaArray } from '../../../adapters/reporteVentaAdapter';
import { adaptTipoPlanArray } from '../../../adapters/tipoPlanAdapter';
import { adaptTipoServicioArray } from '../../../adapters/tipoServicioAdapter';
import { adaptUbicacionArray } from '../../../adapters/ubicacionAdapter';
import { GET_ALL_FIGURA_PROFESIONAL } from '../../../data/graphQL/queries/PlanCuidado/getFiguraProfesionales';
import { GET_ALL_FRECUENCIA_PROFESIONALES } from '../../../data/graphQL/queries/PlanCuidado/getFrecuenciaProfesional';
import { GET_ALL_GRUPO_PROFESIONALES } from '../../../data/graphQL/queries/PlanCuidado/getGrupoProfesionales';
import { GET_ALL_MODALIDAD_PROFESIONAL_COBRO } from '../../../data/graphQL/queries/PlanCuidado/getModalidadProfesionalCobro';
import { GET_ALL_MODALIDAD_VISITA } from '../../../data/graphQL/queries/PlanCuidado/getModalidadVisita';
import { GET_ALL_PLAN_CUIDADO_DURACION_FASE } from '../../../data/graphQL/queries/PlanCuidado/getPlanCuidadoDuracionFase';
import { GET_ALL_TIPO_CAPACITACION } from '../../../data/graphQL/queries/PlanCuidado/getTipoCapacitacion';
import { GET_ALL_TIPO_PROFESIONALES } from '../../../data/graphQL/queries/PlanCuidado/getTipoProfesionales';
import { GET_ALL_TIPO_PROFESIONALES_ESPECIALIDAD } from '../../../data/graphQL/queries/PlanCuidado/getTipoProfesionalesEspecialidad';

import { useNavigate } from 'react-router-dom';
import { adaptTipoModuloArray } from '../../../adapters/tipoModuloAdapter';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import { GET_ALL_COMPLEJIDAD } from '../../../data/graphQL/queries/PlanCuidado/getComplejidad';
import { GET_DATA_TIPO_MODULO } from '../../../data/graphQL/queries/PlanCuidado/getDataTipoModulo';
import { GET_ALL_REPORTE_VENTA } from '../../../data/graphQL/queries/PlanCuidado/getReporteVenta';
import { GET_ALL_TIPO_PLAN } from '../../../data/graphQL/queries/PlanCuidado/getTipoPlan';
import { GET_ALL_TIPO_SERVICIO } from '../../../data/graphQL/queries/PlanCuidado/getTipoServicio';
import { GET_ALL_UBICACION } from '../../../data/graphQL/queries/PlanCuidado/getUbicacion';
import { GET_TIPO_MODULO } from '../../../data/graphQL/queries/TipoModulo/queries';

export const PreviewValidateContent = ({ setChildrenAction }) => {
  const location = useLocation();
  const stateData = location.state;
  const editFullFormData = stateData?.Plan;
  const allowedWriteParam = stateData?.AllowedWrite;
  const estadoPlan = stateData?.EstadoPlan;
  const navigate = useNavigate();
  const [franjaEtaria, setFranjasEtaria] = useState([]);
  const [disabledRechazar, setDisabledRechazar] = useState(false);

  const [planData, setPlanData] = useState(editFullFormData);
  const [allowedWrite, setAllowedWrite] = useState(allowedWriteParam);

  useEffect(() => {
    if (allowedWrite) {
      setChildrenAction(() =>
        <div className='buttons-preview-actions'>
          {estadoPlan !== 4 &&
            <div className='button-rechazar'>
              <CustomButton
                variant='outlined'
                onClick={handleClickOpen}>

                Rechazar
              </CustomButton>
            </div>
          }
          {(estadoPlan === 1 || estadoPlan === 4) &&
            <CustomButton
              onClick={handleClickAprobar}>

              Aprobar
            </CustomButton>
          }
        </div>);
    }
  }, []);

  //Datos Generales
  //#region Datos Generales    
  const [tipoServicios, setTipoServicios] = useState([]);
  const [ubicaciones, setUbicaciones] = useState([]);
  const [complejidades, setComplejidades] = useState([]);
  const [reporteVentas, setReporteVentas] = useState([]);
  const [tipoPlanes, setTipoPlanes] = useState([]);
  const [tipoModulos, setTipoModulos] = useState([]);

  useEffect(() => {

    if (!tipoServiciosLoading) {
      getTipoServicios();
    }

    if (!ubicacionesLoading) {
      getUbicaciones();
    }

    if (!franjasEtariaLoading) {
      getFranjasEtaria();
    }

    if (!complejidadesLoading) {
      getComplejidades();
    }

    if (!tipoPlanesLoading) {
      getTipoPlanes();
    }
    if (!tipoModulosLoading) {
      getTipoModulos();
    }
  }, []);

  const [getDataTipoModulo, { data: tipoModuloFullData }] = useLazyQuery(GET_DATA_TIPO_MODULO, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!planData?.datosGenerales.idTipoModulo) return;
    getDataTipoModulo({ variables: { idTipoModulo: planData?.datosGenerales.idTipoModulo } });
  }, [planData?.datosGenerales.idTipoModulo])

  useEffect(() => {
    if (!tipoModuloFullData) return;

    setPlanData(previousData => ({
      ...previousData,
      datosGenerales: {
        ...previousData.datosGenerales,
        idReporteVenta: tipoModuloFullData.dataTipoModulo.valorEsperado.idTipoModuloReporta
      }
    }));
  }, [tipoModuloFullData])


  const [getTipoServicios, { loading: tipoServiciosLoading, data: tipoServicioData }] = useLazyQuery(GET_ALL_TIPO_SERVICIO, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!tipoServicioData) return;
    setTipoServicios(adaptTipoServicioArray(tipoServicioData));
  }, [tipoServicioData])

  const [getUbicaciones, { loading: ubicacionesLoading, data: ubicacionData }] = useLazyQuery(GET_ALL_UBICACION, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!ubicacionData) return;
    setUbicaciones(adaptUbicacionArray(ubicacionData));
  }, [ubicacionData])

  const [getFranjasEtaria, { loading: franjasEtariaLoading, data: franjaEtariaData }] = useLazyQuery(GET_ALL_FRANJA_ETARIA, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!franjaEtariaData) return;
    setFranjasEtaria(adaptFranjaEtariaArray(franjaEtariaData));
  }, [franjaEtariaData])

  const [getComplejidades, { loading: complejidadesLoading, data: complejidadData }] = useLazyQuery(GET_ALL_COMPLEJIDAD, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!complejidadData) return;
    setComplejidades(adaptComplejidadArray(complejidadData));
  }, [complejidadData])

  const [getReporteVentas, { loading: reporteVentasLoading, data: reporteVentaData }] = useLazyQuery(GET_ALL_REPORTE_VENTA, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!reporteVentaData) return;
    setReporteVentas(adaptReporteVentaArray(reporteVentaData));
  }, [reporteVentaData])

  const [getTipoPlanes, { loading: tipoPlanesLoading, data: tipoPlanData }] = useLazyQuery(GET_ALL_TIPO_PLAN, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!tipoPlanData) return;
    setTipoPlanes(adaptTipoPlanArray(tipoPlanData));
  }, [tipoPlanData])

  const [getTipoModulos, { loading: tipoModulosLoading, data: tipoModuloData }] = useLazyQuery(GET_TIPO_MODULO, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!tipoModuloData) return;
    setTipoModulos(adaptTipoModuloArray(tipoModuloData));
  }, [tipoModuloData])
  //#endregion

  //Clientes
  const initialColumnsClientes = [
    {
      field: 'codigoSapCliente',
      headerName: 'Cod cliente'
    },
    {
      field: 'nombre',
      headerName: 'Cliente'
    },
    {
      field: 'codigoEspCliente',
      headerName: 'Cod. Financiador'
    },
    {
      field: 'requiereFacturacion',
      headerName: 'Factura',
      type: 'boolean'
    },
    {
      headerName: 'Atributos',
      field: 'atributos',
      flex: 0.4,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        const propsAModificar = Object.entries(row)?.map(([key, _]) => key).filter((nombre) => nombre.includes('atributo'));
        const renderChips = Object.entries(row)?.
          filter(([key, _]) => propsAModificar.includes(key))?.
          map(([_, value], index) => {
            if (value !== '') {
              return (
                <Chip key={value + index} label={value} />);

            }
          });
        return renderChips;
      }
    }];

  const columnsClientes = useMemo(() => generateColumnsDefaultConfiguration(initialColumnsClientes), []);


  //Insumos
  const initialColumnsInsumo = [
    {
      field: 'idTipoInsumo',
      headerName: 'Tipo',
      flex: 0.4,
      valueGetter: (idTipoInsumo) => tipoInsumos.find((insumo) => insumo.id == idTipoInsumo)?.displayName
    },
    {
      field: 'insumo',
      headerName: 'Insumo',
      flex: 0.6,
      valueGetter: (insumo) => insumo?.description
    },
    {
      field: 'cantidad',
      flex: 0.2,
      headerName: 'Cantidad'
    },
    {
      field: 'baseCalculo',
      headerName: 'Base Cálculo',
      flex: 0.3
    },
    {
      field: 'idFranjaEtaria',
      headerName: 'Franja Etarea',
      flex: 0.3,
      valueGetter: (idFranjaEtaria) => franjaEtaria.find((fEtaria) => fEtaria?.id == idFranjaEtaria)?.displayName || ''
    },
  ];
  const columnsInsumo = generateColumnsDefaultConfiguration(initialColumnsInsumo);


  const [alergias, setAlergias] = useState([]);
  const [lumenes, setLumenes] = useState([]);
  const [tipoInsumos, setTipoInsumos] = useState([]);
  const [presentacionNutricion, setPresentacionNutricion] = useState([]);
  const [grupoObligatorio, setGrupoObligatorio] = useState([]);
  const [tipoAcceso, setTipoAcceso] = useState([]);
  const [getPresentacionNutricion, { loading: presentacionNutricionLoading, data: presentacionNutricionData }] = useLazyQuery(GET_ALL_PRESENTACION_NUTRICION, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!presentacionNutricionData) return;
    setPresentacionNutricion(adaptPresentacionNutricionArray(presentacionNutricionData));
  }, [presentacionNutricionData])

  const [getGrupoObligatorio, { loading: grupoObligatorioLoading, data: grupoObligatorioData }] = useLazyQuery(GET_GRUPO_OBLIGATORIO, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!grupoObligatorioData) return;
    setGrupoObligatorio(adaptGrupoObligatorioArray(grupoObligatorioData));
  }, [grupoObligatorioData])

  const [getAlergias, { loading: alergiasLoading, data: alergiasData }] = useLazyQuery(GET_ALL_ALERGIAS, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!alergiasData) return;
    setAlergias(adaptAlergiaArray(alergiasData));
  }, [alergiasData])

  const [getFranjasEtarias, { loading: franjasEtariasLoading, data: franjaEtareaData }] = useLazyQuery(GET_ALL_FRANJA_ETARIA, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!franjaEtareaData) return;
    setFranjasEtaria(adaptFranjaEtariaArray(franjaEtareaData));
  }, [franjaEtareaData])

  const [getLumenes, { loading: lumenesLoading, data: lumenesData }] = useLazyQuery(GET_LUMENES, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!lumenesData) return;
    setLumenes(adaptLumenesArray(lumenesData));
  }, [lumenesData])

  const [getTipoInsumo, { loading: tipoInsumoLoading, data: tipoInsumoData }] = useLazyQuery(GET_TIPO_INSUMOS, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!tipoInsumoData) return;
    setTipoInsumos(adaptTipoInsumoArray(tipoInsumoData));
  }, [tipoInsumoData])

  const [getTipoAcceso, { loading: tipoAccesoLoading, data: tipoAccesoData }] = useLazyQuery(GET_ALL_TIPO_ACCESO, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!tipoAccesoData) return;
    setTipoAcceso(adaptTipoAccesoArray(tipoAccesoData));
  }, [tipoAccesoData])

  useEffect(() => {
    if (!lumenesLoading) {
      getLumenes();
    }
    if (!tipoInsumoLoading) {
      getTipoInsumo();
    }
    if (!grupoObligatorioLoading) {
      getGrupoObligatorio();
    }
    if (!franjasEtariasLoading) {
      getFranjasEtarias();
    }
    if (!alergiasLoading) {
      getAlergias();
    }
    if (!presentacionNutricionLoading) {
      getPresentacionNutricion();
    }
    if (!tipoAccesoLoading) {
      getTipoAcceso();
    }
    if (!reporteVentasLoading) {
      getReporteVentas();
    }
  }, []);

  //Dietas
  const elecciones = [
    {
      id: 1,
      displayName: "1ra",
      name: "1ra"
    },
    {
      id: 2,
      displayName: "2da",
      name: "2da"
    },
    {
      id: 3,
      displayName: "3ra",
      name: "3ra"
    },
    {
      id: 4,
      displayName: "4ta",
      name: "4ta"
    },
    {
      id: 5,
      displayName: "5ta",
      name: "5ta"
    },
    {
      id: 6,
      displayName: "6ta",
      name: "6ta"
    }];

  const initialColumnsDieta = [
    {
      field: 'eleccion',
      headerName: 'Elección',
      headerAlign: 'left',
      align: 'left',
      valueGetter: (props) => elecciones.find((sc) => sc.id == props)?.displayName
    }];

  const columnsDietas = generateColumnsDefaultConfiguration(initialColumnsDieta);

  useEffect(() => {
    const newDietasSelected = [...(planData.dietas || [])];
    setPlanData((previousData) => ({
      ...previousData,
      dietas: [...newDietasSelected.map((dieta, index) => ({ ...dieta, id: index }))]
    }));
  }, []);



  //Facturacion
  const initialColumnsFacturacion = [
    {
      field: 'id',
      headerName: '#',
      flex: 0.05
    },
    {
      field: 'nombre',
      headerName: 'Documentacion'
    },
    {
      headerName: 'Requiere',
      field: 'action',
      align: 'center',
      headerAlign: 'center',
      flex: 0.09,
      valueGetter: (props) => planData?.documentoFacturaciones?.some((df) => df?.idDocumentoFac == props.id) ? 'SI' : 'NO'
    }];


  const [documentos, setDocumentos] = useState([]);
  useEffect(() => {
    if (!documentosLoading) {
      getDocumentos();
    }
  }, []);

  const [getDocumentos, { loading: documentosLoading, data: documentosData }] = useLazyQuery(GET_DOCUMENTOS, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!documentosData) return;
    setDocumentos(documentosData.documentoFac.items);
  }, [documentosData])

  const columnsFacturacion = useMemo(() => generateColumnsDefaultConfiguration(initialColumnsFacturacion), [planData?.documentoFacturaciones]);

  //Delegaciones
  const [delegaciones, setDelegaciones] = useState([]);


  useEffect(() => {
    if (!delegacionesLoading) {
      getDelegaciones({
        variables: {
          where: {
            or: [
              { descripcion: { ncontains: 'CASA CENTRAL' } }
            ]
          },
          order: [{ descripcion: 'ASC' }]
        }
      });
    }
  }, [])

  const [getDelegaciones, { loading: delegacionesLoading, data: delegacionesData }] = useLazyQuery(GET_DELEGACIONES, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!delegacionesData) return;
    setDelegaciones([...adaptDelegacionArray(delegacionesData)]);
  }, [delegacionesData]);

  //Legales
  const [documentosLegales, setDocumentosLegales] = useState([]);
  const [getDocumentosLegales, { loading: documentosLegalesLoading, data: tipoDocumentosLegalesData }] = useLazyQuery(GET_ALL_DOCUMENTOS_LEGALES, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!tipoDocumentosLegalesData) return;
    setDocumentosLegales(adaptDocumentoLegalArray(tipoDocumentosLegalesData));
  }, [tipoDocumentosLegalesData])

  useEffect(() => {
    if (!documentosLegalesLoading) {
      getDocumentosLegales(({ variables: { idTipoModulo: planData.datosGenerales.idTipoModulo } }));
    }
  }, [])


  //Profesionales
  //#region Profesionales
  const [tipoProfesionales, setTipoProfesionales] = useState([]);
  const [tipoProfesionalesEspecialidad, setTipoProfesionalesEspecialidad] = useState([]);
  const [figuraProfesionales, setFiguraProfesionales] = useState([]);
  const [modalidadVisitas, setModalidadVisitas] = useState([]);
  const [modalidadProfesionalCobro, setModalidadProfesionalCobro] = useState([]);
  const [grupoProfesionales, setGrupoProfesionales] = useState([]);
  //const [registrosEvolucion, setRegistrosEvolucion] = useState([]);
  const [tiposCapacitacion, setTiposCapacitacion] = useState([]);
  const [frecuenciaProfesionales, setFrecuenciaProfesionales] = useState([]);
  const [fases, setFases] = useState([]);
  const [duracion, setDuracion] = useState([]);
  const [criterios, setCriterios] = useState([]);

  const [getTipoProfesionales, { loading: tipoProfesionalesLoading, data: tipoProfesionalesData }] = useLazyQuery(GET_ALL_TIPO_PROFESIONALES, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!tipoProfesionalesData) return;
    setTipoProfesionales(adaptTipoProfesionalArray(tipoProfesionalesData));
  }, [tipoProfesionalesData])

  const [getTipoProfesionalesEspecialidad, { loading: tipoProfesionalesEspecialidadLoading, data: tipoProfesionalesEspecialidadData }] = useLazyQuery(GET_ALL_TIPO_PROFESIONALES_ESPECIALIDAD, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!tipoProfesionalesEspecialidadData) return;
    setTipoProfesionalesEspecialidad(adaptTipoProfesionalEspecialidadArray(tipoProfesionalesEspecialidadData));
  }, [tipoProfesionalesEspecialidadData])

  const [getGrupoProfesionales, { loading: grupoProfesionalesLoading, data: grupoProfesionalesData }] = useLazyQuery(GET_ALL_GRUPO_PROFESIONALES, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!grupoProfesionalesData) return;
    setGrupoProfesionales(adaptGrupoProfesionalArray(grupoProfesionalesData));
  }, [grupoProfesionalesData])


  const [getFiguraProfesionales, { loading: figuraProfesionalesLoading, data: figuraProfesionalesData }] = useLazyQuery(GET_ALL_FIGURA_PROFESIONAL, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!figuraProfesionalesData) return;
    console.log('figuras', figuraProfesionalesData)
    setFiguraProfesionales(adaptFiguraProfesionalByIdArray(figuraProfesionalesData));
  }, [figuraProfesionalesData])


  const [getModalidadVisitas, { loading: modalidadVisitasLoading, data: modalidadVisitasData }] = useLazyQuery(GET_ALL_MODALIDAD_VISITA, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!modalidadVisitasData) return;
    setModalidadVisitas(adaptModalidadVisitaArray(modalidadVisitasData));
  }, [modalidadVisitasData])

  const [getModalidadProfesionalCobro, { loading: modalidadProfesionalLoading, data: modalidadProfesionalData }] = useLazyQuery(GET_ALL_MODALIDAD_PROFESIONAL_COBRO, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!modalidadProfesionalData) return;
    setModalidadProfesionalCobro(adaptModalidadProfesionalCobroArray(modalidadProfesionalData));
  }, [modalidadProfesionalData])

  const [getTipoCapacitacion, { loading: tipoCapacitacionLoading, data: tipoCapacitacionData }] = useLazyQuery(GET_ALL_TIPO_CAPACITACION, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!tipoCapacitacionData) return;
    setTiposCapacitacion(adaptTipoCapacitacionArray(tipoCapacitacionData));
  }, [tipoCapacitacionData])

  const [getFrecuenciaProfesionales, { loading: frecuenciaProfesionalesLoading, data: frecuenciaProfesionalesData }] = useLazyQuery(GET_ALL_FRECUENCIA_PROFESIONALES, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!frecuenciaProfesionalesData) return;
    setFrecuenciaProfesionales(adaptFrecuenciaProfesionalArray(frecuenciaProfesionalesData));
  }, [frecuenciaProfesionalesData])

  const [getFases, { loading: fasesLoading, data: fasesData }] = useLazyQuery(GET_ALL_FASES, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!fasesData) return;
    setFases(adaptFaseArray(fasesData));
  }, [fasesData])

  const [getDuracion, { loading: duracionLoading, data: duracionData }] = useLazyQuery(GET_ALL_PLAN_CUIDADO_DURACION_FASE, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!duracionData) return;
    setDuracion(adaptPlanCuidadoDuracionFaseArray(duracionData));
  }, [duracionData])

  const [getCriterios, { loading: criteriosLoading, data: criteriosData }] = useLazyQuery(GET_ALL_CRITERIOS, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!criteriosData) return;
    setCriterios(adaptCriterioArray(criteriosData));
  }, [criteriosData]);

  useEffect(() => {
    if (!tipoProfesionalesEspecialidadLoading) {
      getTipoProfesionalesEspecialidad({
        variables: {
          idTipoProfesional: 0
        }
      });
    }
  }, []);

  useEffect(() => {
    if (!tipoProfesionalesLoading) {
      getTipoProfesionales();
    }
  }, []);

  useEffect(() => {
    if (!modalidadProfesionalLoading) {
      getModalidadProfesionalCobro();
    }
  }, []);

  useEffect(() => {
    if (!grupoProfesionalesLoading) {
      getGrupoProfesionales();
    }
  }, []);

  useEffect(() => {
    if (!modalidadVisitasLoading) {
      getModalidadVisitas();
    }
  }, []);

  useEffect(() => {
    if (!frecuenciaProfesionalesLoading) {
      getFrecuenciaProfesionales();
    }
  }, []);

  useEffect(() => {
    if (!figuraProfesionalesLoading) {
      getFiguraProfesionales(
        {
          variables: {
            idTipoProfesional: 0
          }
        }
      );
    }
  }, []);
  useEffect(() => {
    if (!tipoCapacitacionLoading) {
      getTipoCapacitacion({
        variables: {
          idTipoProfesional: 0
        }
      });
    }
  }, []);


  // useEffect(() => {
  //     if (!registrosEvolucionLoading) {
  //         getRegistrosEvolucion();
  //     }
  // }, [])


  useEffect(() => {
    if (!criteriosLoading) {
      getCriterios();
    }
  }, []);

  useEffect(() => {
    if (!fasesLoading) {
      getFases();
    }
  }, []);

  useEffect(() => {
    if (!duracionLoading) {
      getDuracion();
    }
  }, []);

  const initialColumnsProfesionales = [
    {
      field: 'idTipoProfesional',
      headerName: 'Tipo de profesional',
      valueGetter: (idTipoProfesional) => {
        return tipoProfesionales?.find((tp) => tp.id === idTipoProfesional)?.displayName;
      }
    },
    {
      field: 'idFiguraProfesional',
      headerName: 'Responsabilidad',
      valueGetter: (idFiguraProfesional) => {
        return figuraProfesionales?.find((tp) => tp.id === idFiguraProfesional)?.displayName;
      }
    },
    {
      field: 'idModalidadProfesionalCobro',
      headerName: 'Modalidad',
      valueGetter: (idModalidadProfesionalCobro) => {
        return modalidadProfesionalCobro?.find((tp) => tp.id === idModalidadProfesionalCobro)?.displayName;
      }
    },
    {
      field: 'idFrecuenciaProfesional',
      headerName: 'Frecuencia',
      valueGetter: (idFrecuenciaProfesional) => {
        return frecuenciaProfesionales?.find((tp) => tp.id === idFrecuenciaProfesional)?.displayName;
      }
    },
    {
      field: 'orden',
      headerName: 'Orden'
    },
    {
      field: 'duracion',
      headerName: 'Duración',
      valueGetter: (duracionValue) => {
        return duracion?.find((tp) => tp.id === duracionValue)?.displayName;
      }
    },
  ];

  const columnsProfesionales = generateColumnsDefaultConfiguration(initialColumnsProfesionales);
  //#endregion

  //Actions
  const handleClickAprobar = () => {
    changeStatePlanCuidado({
      variables: {
        idPlanCuidado: planData.datosGenerales.idPlanCuidado,
        state: 'APROBADO'
      }
    });
  };

  const handleClickRechazar = () => {
    setDisabledRechazar(true);
    changeStatePlanCuidado({
      variables: {
        idPlanCuidado: planData.datosGenerales.idPlanCuidado,
        state: 'RECHAZADO',
        motivoRechazo: motivoRechazo
      }
    });
  };

  const [changeStatePlanCuidado, { loading: changeStateLoading }] = useMutation(CHANGE_STATE_PLANCUIDADO, {
    onCompleted: (data) => {
      navigate('/validarPlan');
    }
  }
  );
  const [open, setOpen] = useState(false);
  const [motivoRechazo, setMotivoRechazo] = useState('');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return <>
    {/* Datos Generales */}
    <div className='card-container'>
      <strong> Datos generales</strong>
      <Grid
        container
        justifyContent={'space-between'}
        columns={{
          xs: 2,
          md: 4
        }}
        rowGap={2}>

        <Grid size={{ md: 1 }}>
          <strong>Identificador</strong>
          <br></br>
          <label>{planData.datosGenerales.idPlanCuidado}</label>
        </Grid>
        <Grid size={{ md: 1 }}>
          <strong>Código SAP</strong>
          <br></br>
          <label>{planData.datosGenerales.codigoSap}</label>
        </Grid>
        <Grid size={{ md: 1 }}>
          <strong>Nombre</strong>
          <br></br>
          <label>{planData.datosGenerales.nombre}</label>
        </Grid>
        <Grid size={{ md: 1 }}>
          <strong>Activo</strong>
          <br></br>
          <Chip className='chip-preview' label={planData.datosGenerales.activo ? 'SI' : 'NO'} />
        </Grid>

        <Grid size={{ md: 4 }}>
          <strong>Tipo</strong>
          <br></br>
          <label>{tipoModulos?.find((tp) => tp.id === planData.datosGenerales.idTipoModulo)?.displayName}</label>
        </Grid>

        <Grid size={{ md: 1 }}>
          <strong>Profesionales</strong>
          <br></br>
          <Chip className='chip-preview' label={planData.datosGenerales.profesionales ? 'SI' : 'NO'} />
        </Grid>
        <Grid size={{ md: 1 }}>
          <strong>TM</strong>
          <br></br>
          <Chip className='chip-preview' label={planData.datosGenerales.tm ? 'SI' : 'NO'} />
        </Grid>
        <Grid size={{ md: 1 }}>
          <strong>Envio</strong>
          <br></br>
          <Chip className='chip-preview' label={planData.datosGenerales.envios ? 'SI' : 'NO'} />
        </Grid>

        <Grid size={{ md: 1 }}>
          <strong>Cotizado</strong>
          <br></br>
          <Chip className='chip-preview' label={planData.datosGenerales.cotizado ? 'SI' : 'NO'} />
        </Grid>
        <Grid size={{ md: 1 }}>
          <strong>Tipo de servicio</strong>
          <br></br>
          <label>{tipoServicios?.find((ts) => ts.id === planData.datosGenerales.idTipoServicio)?.displayName}</label>
        </Grid>
        <Grid size={{ md: 1 }}>
          <strong>Posee esquema</strong>
          <br></br>
          <Chip className='chip-preview' label={planData.datosGenerales.esquema ? 'SI' : 'NO'} />
        </Grid>
        <Grid size={{ md: 1 }}>
          <strong>Complejidad CO</strong>
          <br></br>
          <Chip className='chip-preview' label={planData.datosGenerales.complejidad ? 'SI' : 'NO'} />
        </Grid>

        <Grid size={{ md: 1 }}>

        </Grid>

        <Grid size={{ md: 1 }}>
          <strong>Ubicacion</strong>
          <br></br>
          <label>{ubicaciones?.find((u) => u.id === planData.datosGenerales.idUbicacionPlan)?.displayName}</label>
        </Grid>
        <Grid size={{ md: 1 }}>
          <strong>Franja etaria</strong>
          <br></br>
          <label>{franjaEtaria?.find((fe) => fe.id === planData.datosGenerales.idFranjaEtaria)?.displayName}</label>
        </Grid>
        <Grid size={{ md: 1 }}>
          <strong>Complejidad</strong>
          <br></br>
          <label>{complejidades?.find((c) => c.id === planData.datosGenerales.idComplejidad)?.displayName}</label>
        </Grid>
        <Grid size={{ md: 1 }}>
          <strong>Reporte de ventas</strong>
          <br></br>
          <label>{tipoModulos.find((tm) => tm.abreviacion === reporteVentas?.find((rv) => rv.id === planData.datosGenerales.idReporteVenta)?.displayName)?.displayName}</label>
        </Grid>

        <Grid size={{ md: 1 }}>
          <strong>Tope calorías pediatrico por día</strong>
          <br></br>
          <label>{planData.datosGenerales.topeCalPediatrico}</label>
        </Grid>
        <Grid size={{ md: 1 }}>
          <strong>Tope calorías adulto por día</strong>
          <br></br>
          <label>{planData.datosGenerales.topeCalAdulto}</label>
        </Grid>

        <Grid size={{ md: 2 }}>

        </Grid>

        <Grid size={{ md: 4 }}>
          <strong> Observaciones </strong>
          <br></br>
          <label>{planData.datosGenerales.observacion}</label>
        </Grid>
      </Grid>
    </div>
    {/* Delegaciones */}
    <div className='card-container'>
      <strong>Delegaciones</strong>
      <div className='delegaciones-chips-container'>
        {
          planData?.delegaciones?.map((value, index) => {
            if (value !== '') {
              return (
                <Chip className='chip-preview' key={value + index} label={delegaciones.find((f) => f.id === value?.idDelegacion)?.name} />);

            }
          })
        }
      </div>
    </div>
    {/* clientes */}
    <div className='card-container'>
      <strong>Clientes</strong>
      {
        planData?.clientes.length === 0 &&
        <div className='card-sin-ingresos'>
          <label> No hay ningun ingreso </label>
        </div>
      }
      {
        planData?.clientes.length != 0 &&
        <div className='clientes-grilla'>
          <DataGridGenerico
            hideFooterPagination={true}
            toolbar={false}
            columns={columnsClientes}
            rows={planData?.clientes} />

        </div>
      }
    </div>
    {/* Legales */}
    <div className='card-container'>
      <strong>Legales</strong>
      <Grid
        container
        justifyContent={'space-between'}
        columns={{
          xs: 2,
          md: 4
        }}>

        <Grid size={{ md: 2 }}>
          <strong>Bloquea envío</strong>
          <br></br>
          <label>{planData.documentoLegales.bloqueaEnvio ? 'SI' : 'NO'}</label>
        </Grid>
        <Grid size={{ md: 2 }}>
          <strong>Fecha de firma bloquea inicio</strong>
          <br></br>
          <label>{planData.documentoLegales.firmaBloqueaInicio ? 'SI' : 'NO'}</label>
        </Grid>
      </Grid>
    </div>
    {/* Facturacion */}
    <div className='card-container'>
      <strong>Facturación</strong>
      <DataGridGenerico
        hideFooterPagination={true}
        columns={columnsFacturacion}
        rows={documentos || []}
        toolbar={false} />

    </div>
    {/* Insumos */}
    <div className='card-container'>
      <strong>Insumos</strong>
      {
        planData?.insumos.length === 0 &&
        <div className='card-sin-ingresos'>
          <label> No hay ningun ingreso </label>
        </div>
      }
      {
        planData?.insumos.length != 0 &&
        <div className='insumoss-grilla'>
          <DataGridGenerico
            hideFooterPagination={true}
            toolbar={false}
            columns={columnsInsumo}
            rows={planData?.insumos} />

        </div>
      }

    </div>
    {/* Dietas */}
    <div className='card-container'>
      <strong>Elección</strong>
      {
        planData?.dietas.length === 0 &&
        <div className='card-sin-ingresos'>
          <label> No hay ningun ingreso </label>
        </div>
      }
      {
        planData?.dietas.length != 0 &&
        <DataGridGenerico
          hideFooterPagination={true}
          toolbar={false}
          columns={columnsDietas}
          rows={planData?.dietas} />

      }

    </div>
    {/* Profesionales */}
    <div className='card-container'>
      <strong>Profesionales</strong>
      {
        planData?.fases.length === 0 &&
        <div className='card-sin-ingresos'>
          <label> No hay ningun ingreso </label>
        </div>
      }
      {
        planData?.fases.length != 0 &&
        planData?.fases?.map((fase) => {
          const faseProfesionals = planData?.profesionales?.filter((profesional) => profesional.idPlanCuidadoFase === fase?.idPlanCuidadoFase);
          const faseName = fases?.find((f) => f.id === fase?.idFase)?.displayName;
          const duration = duracion?.find((d) => d.id === fase?.idPlanCuidadoDuracionFase)?.displayName;

          if (Boolean(faseProfesionals.length)) {
            return (
              <div key={fase?.idFase} className='fase-detail-container'>
                <div className='fase-detail-label'>
                  Fase: <p className='label-bold'>{faseName}</p> <p className='label-divider'>|</p>
                  Duración: <p className='label-bold'>{duration}</p>
                </div>
                <DataGridGenerico
                  columns={columnsProfesionales}
                  rows={faseProfesionals}
                  toolbar={false}
                  hideFooter />

                {fase?.planCuidadoFaseCriterio?.length > 0 &&
                  <TextField
                    label='Criterios de la fase'
                    fullWidth
                    variant='outlined'
                    className='chip-input'
                    disabled
                    InputProps={{
                      startAdornment: fase?.planCuidadoFaseCriterio?.map((criterio, index) => {
                        const chipLabel = criterios?.find((c) => c.id == criterio.idCriterio)?.displayName;
                        return (
                          <Chip
                            key={index}
                            label={chipLabel}
                            className='fase-chip' />);


                      })
                    }} />

                }
              </div>);

          }
        })
      }
    </div>

    <CustomDialog
      open={open}
      onClose={handleClose}
      title='Rechazo'
      onCancel={handleClose}
      onAccept={handleClickRechazar}
      acceptDisabled={disabledRechazar}
      acceptText='Rechazar'>

      <TextField
        autoFocus
        margin="dense"
        id="name"
        label="Motivo"
        type="text"
        fullWidth
        variant="standard"
        value={motivoRechazo}
        onChange={(e) => setMotivoRechazo(e.target.value)} />

    </CustomDialog>
  </>;
};